import {
  DraftQuestionnaireEntry,
  QuestionSettingCode
} from '../../../data/model/questionnaire'
import { isSettingEnabled } from '../../../utils/questionnaireUtils'

export interface WaveVisibility {
  /** The entry's own `hidden` setting is enabled. */
  hidden: boolean
  /** Its section is hidden. The entry's own setting is left untouched. */
  hiddenBySection: boolean
}

export const isHiddenInWave = (
  entryItem: DraftQuestionnaireEntry['entryItem']
): boolean =>
  'settingValues' in entryItem &&
  isSettingEnabled(entryItem.settingValues, QuestionSettingCode.HiddenInWave)

export const waveVisibilityLabel = ({
  hidden,
  hiddenBySection
}: WaveVisibility): string | undefined => {
  // Say when both apply: unhiding the section leaves this entry hidden.
  if (hidden && hiddenBySection) {
    return 'Hidden in this wave (also hidden by section)'
  }
  if (hiddenBySection) {
    return 'Hidden in this wave by section'
  }
  return hidden ? 'Hidden in this wave' : undefined
}

/** An entry's own setting can always be cleared; one hidden only by its section has none to change. */
export const canToggleWaveVisibility = ({
  hidden,
  hiddenBySection
}: WaveVisibility): boolean => hidden || !hiddenBySection

export const waveVisibilityActionLabel = (
  visibility: WaveVisibility
): string => {
  if (visibility.hidden) {
    return 'Unhide in this wave'
  }
  return visibility.hiddenBySection
    ? 'Unhide section to show in this wave'
    : 'Hide in this wave'
}
